import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
// import {decode as base64_decode, encode as base64_encode} from 'base-64';
// import "../Spin.css";

import AuthContext from "../context/AuthContext";
import crossIcon from "../assets/images/cross-black.svg";
import logoIcon from "../assets/images/logo.png";
import SpinWheel from "./SpinWheel/SpinWheel";

function FreeSpin() {
    const navigate = useNavigate();
    const [loggedInData, setLoggedInData] = useState(null);
    const [error, setError] = useState(null);
    let { profileData } = useContext(AuthContext);
    const closeFreeSpin = () => {
        navigate("/");
    };
    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
    }, []);
    // console.log("profileData",profileData)
    return (
        <div className="App spinPage">
            <div id="cricket-page-wrapper" className="sport-page-wrapper">
                <div
                    className="download-bar spin-theme"
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                // style={{ position: "relative" }}
                >
                    <img src={logoIcon} alt="download" style={{ width: '100px' }} class="mr-2 c-radis" />
                    {/* <div className="mr-1 col text-center">
            <b>WELCOME FREE SPIN</b>
          </div> */}
                    <span
                        class="dark-theme_btn"
                        style={{ cursor: "pointer" }}
                        onClick={closeFreeSpin}
                    >
                        <img
                            width="15"
                            height="15"
                            src={crossIcon}
                            alt="download"
                            className="mr-2 crose-icon"
                        />
                    </span>
                </div>
                <div className="iframe-container" style={{ paddingTop: '70px' }}>
                    <SpinWheel profileData={profileData} />
                </div>
            </div>
        </div>
    );
}

export default FreeSpin;
